export const crudConfig = {
    metadata: {
        endpoint: 'cds/criteriaresourceparams',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'cds',
                args: [],
                query: {}
            }
        }
    }
};

export default crudConfig;
